module.exports = __webpack_public_path__ + "static/media/pic22.5fbe043f.jpg";